/**
 * В число
 * @param hex
 * @return {string}
 */
 export const hex2rgb = (hex: string): string => {
    const bigint = parseInt(hex.replace('#', ''), 16);
    return `${(bigint >> 16) & 255},${(bigint >> 8) & 255},${bigint & 255}`;
};
